export default __webpack_public_path__ + "static/media/ic_banner_reward.ef5f0be3.png";